"use client";

import { useEffect, useRef, useState } from "react";

export function useScrollSpy(offset = 0) {
  const [activeId, setActiveId] = useState<string | null>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveId(entry.target.id);
        }
      });
    };

    observerRef.current = new IntersectionObserver(observerCallback, {
      rootMargin: `-${offset}px 0px -80% 0px`,
      threshold: 0,
    });

    const elements = document.querySelectorAll<HTMLElement>("section[id]");

    elements.forEach((el) => observerRef.current?.observe(el));

    return () => {
      observerRef.current?.disconnect();
    };
  }, [offset]);

  return activeId;
}
